import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import placePaymentsService from '../../services/placePaymentsService';

const KEY = (placeId) => ['place', placeId, 'payments'];

export function usePlacePayments(placeId, options = {}) {
  return useQuery({
    queryKey: KEY(placeId),
    queryFn: () => placePaymentsService.getByPlace(placeId),
    enabled: !!placeId && (options.enabled ?? true),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    ...options,
  });
}

export function useSetPlacePayments(placeId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ paymentIds, confirmCascade }) =>
      placePaymentsService.setAll(placeId, paymentIds, confirmCascade),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY(placeId) });
      qc.invalidateQueries({ queryKey: ['places'] });      // invalidar BFF entities
      qc.invalidateQueries({ queryKey: ['entities'] });    // se aplicável
    },
  });
}

export function usePlacePaymentCascadePreview(placeId, paymentId, enabled = true) {
  return useQuery({
    queryKey: ['place', placeId, 'payments', paymentId, 'cascade-preview'],
    queryFn: () => placePaymentsService.previewCascade(placeId, paymentId),
    enabled: enabled && !!placeId && !!paymentId,
    staleTime: 0,
  });
}
